import React, { useState } from 'react';
import axios from 'axios';

function Login({ onLogin, apiUrl }) {
  const [callsign, setCallsign] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${apiUrl}/api/auth/login`, {
        callsign: callsign.trim()
      });
      onLogin(response.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-logo">Aurora</h1>
        <p className="login-subtitle">Field Day Logger</p>
        
        <form className="login-form" onSubmit={handleSubmit}>
          <input
            type="text"
            className="login-input"
            placeholder="CALLSIGN"
            value={callsign}
            onChange={(e) => setCallsign(e.target.value.toUpperCase())}
            autoFocus
            autoComplete="off"
            autoCapitalize="characters"
          />
          
          {error && <div className="error-message">{error}</div>}
          
          <button type="submit" className="btn" disabled={loading || !callsign.trim()}>
            {loading ? 'Checking...' : 'Enter'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
